import { useEffect, useRef, useState } from 'react';

import { apiUrl, fetchJson } from '../../apiBase';

const useMaarifBooks = ({ schoolId, lessonId, gradeLevel, notifyError }) => {
  const [books, setBooks] = useState([]);
  const [loadingBooks, setLoadingBooks] = useState(false);
  const reqIdRef = useRef(0);

  useEffect(() => {
    setBooks([]);

    if (!schoolId || !lessonId || !gradeLevel) return;

    const rid = ++reqIdRef.current;
    const run = async () => {
      setLoadingBooks(true);
      try {
        const params = new URLSearchParams();
        params.set('lesson_id', String(lessonId));
        params.set('grade_level', String(gradeLevel));

        const res = await fetchJson(apiUrl(`/admin/maarif/books?${params.toString()}`));
        if (rid !== reqIdRef.current) return;
        if (!res.ok) throw new Error('books');
        const rows = await res.json();
        const items = (rows || [])
          .filter((r) => r && r.id != null)
          .map((r) => ({
            id: r.id,
            lesson_id: r.lesson_id,
            grade_level: String(r.grade_level || ''),
            book_name: String(r.book_name || ''),
            book_url: r.book_url || null,
          }))
          .filter((r) => r.book_name)
          .sort((a, b) => String(a.book_name).localeCompare(String(b.book_name), 'tr-TR'));
        setBooks(items);
      } catch (e) {
        if (rid !== reqIdRef.current) return;
        notifyError && notifyError('Kitaplar yüklenemedi');
        setBooks([]);
      } finally {
        if (rid !== reqIdRef.current) return;
        setLoadingBooks(false);
      }
    };

    run();
  }, [schoolId, lessonId, gradeLevel, notifyError]);

  return { books, loadingBooks };
};

export default useMaarifBooks;
